// extracted by mini-css-extract-plugin
module.exports = {"whiteBackground":"static-layout-module--whiteBackground--1KAFe"};